export default __webpack_public_path__ + "static/media/cLogo12.806c99ca.jpeg";